import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import "./Graphview.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const GraphView = ({ selectedPatient }) => {
  const [timePeriod, setTimePeriod] = useState(1);

  const diagnosisHistory = selectedPatient?.diagnosis_history || [];

  const sortedHistory = [...diagnosisHistory].sort((a, b) => {
    const dateA = new Date(`${a.month} ${a.year}`);
    const dateB = new Date(`${b.month} ${b.year}`);
    return dateB - dateA;
  });

  const latestEntry = sortedHistory[0];

  const filteredData = sortedHistory.slice(0, timePeriod);

  const months = filteredData.map(
    (entry) => `${entry.month.slice(0, 3)} ${entry.year}`
  );
  const systolicData = filteredData.map(
    (entry) => entry.blood_pressure.systolic.value
  );
  const diastolicData = filteredData.map(
    (entry) => entry.blood_pressure.diastolic.value
  );

  const bloodPressureData = {
    labels: months,
    datasets: [
      {
        label: "Systolic",
        data: systolicData,
        borderColor: "rgba(255, 99, 132, 1)",
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        fill: true,
        tension: 0.4,
        pointRadius: 4,
        pointBackgroundColor: "rgba(255, 99, 132, 1)",
        pointBorderWidth: 2,
      },
      {
        label: "Diastolic",
        data: diastolicData,
        borderColor: "rgba(54, 162, 235, 1)",
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        fill: true,
        tension: 0.4,
        pointRadius: 4,
        pointBackgroundColor: "rgba(54, 162, 235, 1)",
        pointBorderWidth: 2,
      },
    ],
  };

  return (
    <div className="graph-section">
      <div className="center-view">
        <div className="graph-left">
          <div className="graph-left-top">
            <h5>Blood Pressure</h5>
            <div className="period-selection">
              <label htmlFor="timePeriod">Select time period last:</label>
              <select
                id="timePeriod"
                value={timePeriod}
                onChange={(e) => setTimePeriod(parseInt(e.target.value))}
                className="time-period-select"
              >
                <option value={1}>1 Month</option>
                <option value={3}>3 Months</option>
                <option value={6}>6 Months</option>
                <option value={6}>6 Months</option>
                <option value={12}>12 Months</option>
              </select>
              
            </div>
          </div>
          <div style={{ marginTop: "30px" }}>
            <Line data={bloodPressureData} options={{ responsive: true }} />
          </div>
        </div>

        <div className="graph-right">
          {latestEntry ? (
            <>
              <p>
                <strong>Systolic:</strong>
                {latestEntry.blood_pressure.systolic.value}
                <br />
                {latestEntry.blood_pressure.systolic.levels}
              </p>
              <p>
                <strong style={{ marginTop: "10px" }}> <p style={{backgroundColor:"##36A2EB"}} id="icon" ></p>Diastolic:</strong>
                {latestEntry.blood_pressure.diastolic.value}
                <br />
                {latestEntry.blood_pressure.diastolic.levels}
              </p>
            </>
          ) : (
            <p>No recent data available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default GraphView;
